/*
  VV Darkroom Shop (homepage): search placeholder, pack-shot trimming and the film strip.
  Markup: sections/vv-darkroom-shop.liquid

  Film strip: drifts right to left, stops while the pointer is over it, drags with the mouse, swipes on touch,
  arrows step it. The track holds the film list three times; we stay in the middle copy and jump by one
  copy's width when we leave it, which is invisible. A frame opens its product only on a quick, still click.
*/
(function () {
  'use strict';

  // The theme's search snippet has no placeholder option.
  document.querySelectorAll('.vv-ds__find[data-vv-ds-placeholder]').forEach(function (el) {
    var input = el.querySelector('input[type="search"]');
    if (input && !input.placeholder) input.placeholder = el.getAttribute('data-vv-ds-placeholder');
  });

  // Pack shots come with different amounts of transparent margin. Crop each one to its visible box
  // so every film fills its frame the same way. Same-origin CDN images only; anything else is left as is.
  var trimmed = {};
  function trim(img) {
    if (img.dataset.trimmed) return;
    var src = img.currentSrc || img.src;
    if (trimmed[src]) { img.dataset.trimmed = '1'; img.src = trimmed[src]; return; }
    try {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0);
      var d = ctx.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          if (d[(y * w + x) * 4 + 3] > 12) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
      img.dataset.trimmed = '1';
      if (x1 < 0 || ((x1 - x0) > w * 0.94 && (y1 - y0) > h * 0.94)) return;
      var cw = x1 - x0 + 1, ch = y1 - y0 + 1, o = document.createElement('canvas');
      o.width = cw; o.height = ch;
      o.getContext('2d').drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
      trimmed[src] = o.toDataURL('image/png');
      img.removeAttribute('width'); img.removeAttribute('height');
      img.src = trimmed[src];
    } catch (e) { img.dataset.trimmed = '1'; }
  }

  function initStrip(strip) {
    var sc = strip.querySelector('[data-strip-scroller]');
    var track = strip.querySelector('[data-strip-track]');
    if (!sc || !track) return;

    // With only a few films in stock, one copy can be narrower than the screen and the loop point
    // would show a gap. Append more hidden copies so each third of the track is wider than the strip.
    function fill() {
      var third = track.scrollWidth / 3, need = sc.clientWidth + 320;
      if (!third || third >= need) return;
      var unit = Array.prototype.slice.call(track.children, 0, track.children.length / 3);
      var extra = 3 * (Math.ceil(need / third) - 1);
      for (var i = 0; i < extra; i++) {
        unit.forEach(function (node) { track.appendChild(node.cloneNode(true)); });
      }
    }
    function bindTrim() {
      track.querySelectorAll('img:not([data-trim-bound])').forEach(function (img) {
        img.setAttribute('data-trim-bound', '');
        if (img.complete && img.naturalWidth) trim(img);
        else img.addEventListener('load', function () { trim(img); }, { once: true });
      });
    }
    fill(); bindTrim();

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SPEED = parseFloat(strip.getAttribute('data-speed')) || 24;   // px per second
    var period = 0, pos = 0, last = 0, hover = false, focus = false, touching = false;
    var hold = 0, anim = null, drag = null, moved = false, suppress = false, visible = true;

    function measure() { period = track.scrollWidth / 3; }
    function wrap() { if (pos < period) pos += period; else if (pos >= 2 * period) pos -= period; }
    function settle() { pos = sc.scrollLeft; wrap(); sc.scrollLeft = pos; }
    function paused() { return reduce || !visible || hover || focus || touching || drag || performance.now() < hold; }

    function frame(t) {
      var dt = last ? Math.min(t - last, 64) / 1000 : 0; last = t;
      if (anim) {
        // arrow step: own easing, because native smooth scrolling gets cancelled by the drift
        var p = anim.dur ? Math.min(1, Math.max(0, (t - anim.t0) / anim.dur)) : 1;
        pos = anim.from + (anim.to - anim.from) * (1 - Math.pow(1 - p, 3));
        sc.scrollLeft = pos;
        if (p === 1) { anim = null; wrap(); sc.scrollLeft = pos; hold = t + 2500; }
      } else if (!paused()) {
        pos += SPEED * dt; wrap(); sc.scrollLeft = pos;
      }
      requestAnimationFrame(frame);
    }

    measure(); pos = period; sc.scrollLeft = pos;
    requestAnimationFrame(frame);

    window.addEventListener('resize', function () {
      var k = period ? sc.scrollLeft % period : 0;
      fill(); bindTrim(); measure(); pos = period + (k % period); sc.scrollLeft = pos;
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(strip);
    }

    strip.addEventListener('mouseenter', function () { hover = true; });
    strip.addEventListener('mouseleave', function () { hover = false; if (!drag) settle(); });
    sc.addEventListener('focusin', function () { focus = true; });
    sc.addEventListener('focusout', function () { focus = false; });
    sc.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    sc.addEventListener('touchend', function () { touching = false; hold = performance.now() + 2500; }, { passive: true });
    sc.addEventListener('scroll', function () { if (paused() && !drag && !anim) pos = sc.scrollLeft; }, { passive: true });
    sc.addEventListener('scrollend', function () { if (paused() && !drag && !touching && !anim) settle(); });

    // mouse drag (touch scrolls natively)
    sc.addEventListener('dragstart', function (e) { e.preventDefault(); });
    sc.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      e.preventDefault();   // no text selection, no native link drag
      settle(); drag = { x: e.clientX, s: sc.scrollLeft, t: performance.now() }; moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) > 3) { moved = true; sc.classList.add('is-dragging'); }
      if (moved) sc.scrollLeft = drag.s - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      suppress = moved || performance.now() - drag.t > 350;
      drag = null; sc.classList.remove('is-dragging'); settle(); hold = performance.now() + 1500;
      setTimeout(function () { suppress = false; }, 0);
    });
    sc.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; }
    }, true);

    function step(dir) {
      pos = anim ? anim.to : sc.scrollLeft;
      wrap(); sc.scrollLeft = pos;
      var by = 160 * Math.max(2, Math.round(sc.clientWidth * 0.5 / 160));   // whole frames
      anim = { from: pos, to: pos + dir * by, t0: performance.now(), dur: reduce ? 0 : 650 };
    }
    var prev = strip.querySelector('[data-strip-prev]'), next = strip.querySelector('[data-strip-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function init() { document.querySelectorAll('[data-vv-film-strip]').forEach(initStrip); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-vv-film-strip]').forEach(initStrip);
  });
})();
